<template>
  <div>
    <b-modal id="modalEditNotificationsTemalate"
      ref="modalEditNotificationsTemalate"
      :title="$t('Notification template')"
      hide-footer
      @shown="shown" size="xl">

      <div v-if="editItem">
        <b-tabs vertical pills card>
          <b-tab :title="$t('Main')" active>
            <b-form-group v-if="event_options" label-align="right" :label="$t('Event')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="eventVal" :options="event_options"/>
            </b-form-group>
            <b-form-group v-if="event_options" label-align="right" :label="$t('Group')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="item.group_id" :options="optionsGroup"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Subject')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input type="text" v-model="item.subject_template"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Message')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-textarea type="text" rows="3" resize:vertical v-model="item.message_template"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Recovery time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-select v-model="item.recovery_time" :options="recovery_options"/>
            </b-form-group>
            <b-form-group label-align="right" :label="$t('Send at appointed time')" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-checkbox v-model="item.send_at_appointed_time"></b-form-checkbox>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Event Settings')" v-if="!(Object.keys(this.item.settings).length === 0)">
            <b-form-group label-align="right" v-for="it in item.settings" :label="it.name" :key="it.name" label-cols="4" label-cols-xl="4" label-cols-md="4">
              <b-form-input :type="it.type" v-model="it.value"/>
            </b-form-group>
          </b-tab>
          <b-tab :title="$t('Default notification methods')">
            <b-form-group label-align="right" label-cols="1" label-cols-xl="1" label-cols-md="1">
              <b-form-checkbox v-model="item.send_email"> {{ $t('Email') }} </b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" label-cols="1" label-cols-xl="1" label-cols-md="1">
              <b-form-checkbox v-model="item.send_sms"> {{ $t('Sms') }} </b-form-checkbox>
            </b-form-group>
            <b-form-group label-align="right" label-cols="1" label-cols-xl="1" label-cols-md="1">
              <b-form-checkbox v-model="item.send_push"> {{ $t('Push') }} </b-form-checkbox>
            </b-form-group>
          </b-tab>
        </b-tabs>
        <modal-ok-cancel @save="save" @cancel="$bvModal.hide('modalEditNotificationsTemalate')" size="xl"/>
      </div>
    </b-modal>
  </div>
</template>

<script>

export default {
  data () {
    return {
      recovery_options: [
        { value: 'minute', text: 'Minute' },
        { value: 'hour', text: 'Hour' },
        { value: 'day', text: 'Day' },
        { value: 'week', text: 'Week' },
        { value: 'month', text: 'Month' }
      ]
    }
  },
  props: {
    editItem: null,
    eventVal: null,
    event_options: null
  },
  methods: {
    save () {
      let tmp = JSON.parse(JSON.stringify(this.editItem[this.eventVal]))
      tmp.settings = Object.keys(tmp.settings).length === 0 ? '{}' : JSON.stringify(tmp.settings)
      if (tmp.id === 0) {
        this.$store.dispatch('Users/ADD_NOTIFICATION_TEMPLATE', tmp)
        this.$refs.modalEditNotificationsTemalate.hide()
      } else {
        this.$store.dispatch('Users/UPDATE_NOTIFICATION_TEMPLATE', tmp)
      }
      this.$bvModal.hide('modalEditNotificationsTemalate')
    },
    shown () {
    }
  },
  computed: {
    item () {
      return this.editItem[this.eventVal]
    },
    groupUsers () {
      return this.$store.getters['Users/GROUPS']
    },
    optionsGroup () {
      let tmp = []
      let newEl = {
        value: 0,
        text: '---'
      }
      tmp.push(newEl)
      for (let el of this.$store.getters['Users/GROUPS']) {
        let newEl = {
          value: 0,
          text: ''
        }
        newEl.value = el.group_id
        newEl.text = el.group_name
        tmp.push(newEl)
      }
      return tmp
    }
  },
  mounted () {
    this.$store.dispatch('Users/GET_GROUPS')
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/users/notificationsTemapltes/editModal.vue